<nav class="navbar navbar-expand-md navbar-dark fixed-top">
    <a class="navbar-brand" href="#"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse"
      aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link" routerLink="/about" routerLinkActive="active-link">About Me</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/home" routerLinkActive="active-link">Home</a>
        </li>
      </ul>
    </div>
  </nav>